export default "__VITE_ASSET__HqIWG7Dg__"